import * as b2BTransfer from '@wix/auto_sdk_b2btransfer_b-2-b-transfer';

export { b2BTransfer };
